import React from 'react';
import { observer } from 'mobx-react';
import { Button, LinearProgress, TextField } from '@material-ui/core';
import useStyles from './TextAssetBuilder.styles';
import { VariationScore } from 'components/VariationScore';
import { useTextAssetBuilder } from './hooks/useTextAssetBuilder';

export const TextAssetBuilder: React.FC = observer(() => {
  const classes = useStyles();

  const {
    textAsset,
    isShowingPostMaloneScore,
    isSaving,
    isCalculating,
    handleInputChange,
    handleSaveAsset,
    handleRemoveAsset,
    maxLengthLabelAttrs
  } = useTextAssetBuilder();

  return (
    <div className={classes.NewHeadlineTextAssetRoot}>
      {isSaving && <LinearProgress className={classes.LinearProgress} />}
      <TextField
        rows={3}
        rowsMax={20}
        className={classes.TextField}
        variant="outlined"
        defaultValue={textAsset?.text}
        disabled={isSaving}
        onChange={handleInputChange}
        fullWidth
        multiline
        {...maxLengthLabelAttrs()}
      />
      {isShowingPostMaloneScore && (
        <div className={classes.VariationScoreContainer}>
          <VariationScore loading={isCalculating} score={textAsset?.postMaloneScore?.engagementScore || 0} />
        </div>
      )}
      <div className={classes.ButtonGroup}>
        <Button
          color="primary"
          className={classes.Button}
          size="small"
          disabled={isSaving || isCalculating}
          onClick={handleSaveAsset}
        >
          save
        </Button>
        <Button
          color="secondary"
          className={classes.Button}
          size="small"
          disabled={isSaving}
          onClick={handleRemoveAsset}
        >
          cancel
        </Button>
      </div>
    </div>
  );
});
